function getDefaultApiBaseUrl() {
  if (typeof window === "undefined") {
    return "http://localhost:5000";
  }

  const { hostname, origin } = window.location;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";

  // Local dev defaults to the local backend.
  if (isLocalhost) {
    return "http://localhost:5000";
  }

  // Public deployments default to same-origin API routing.
  return origin;
}

const rawApiBaseUrl = process.env.REACT_APP_API_BASE_URL || getDefaultApiBaseUrl();

const normalizedApiBaseUrl = rawApiBaseUrl.endsWith("/")
  ? rawApiBaseUrl.slice(0, -1)
  : rawApiBaseUrl;

export function buildApiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${normalizedApiBaseUrl}${normalizedPath}`;
}
